import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import { formatCreditsWithWord } from '@/features/ai/lib/money'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  cost?: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  onCloseAutoFocus?: (e: Event) => void
}

/** Единственный разрушительный режим всего контракта (§7.2): цену называем
 *  ИМЕННО `overwrite_cost + images_cost`, и говорим, что откатить нечем —
 *  истории правок и снимков в API нет. */
export const OverwriteConfirmDialog = ({
  open,
  cost,
  onOpenChange,
  onConfirm,
  onCloseAutoFocus,
}: Props) => {
  const m = useMessages(messages)
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent onCloseAutoFocus={onCloseAutoFocus}>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.overwriteTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {m.overwriteBody}
            {cost ? m.cost(formatCreditsWithWord(cost)) : ''}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel}</AlertDialogCancel>
          {/* Единственная необратимая операция контракта (§7.2) — красим явно
            деструктивным токеном, как DeleteCourseDialog.tsx: дефолтный
            стиль кнопки не несёт нужного веса «отменить нельзя». */}
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {m.overwriteConfirm}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
